<gen-dynamic-form class="patient-details-wrapper" [formConfig]="inputConfig"
                  [listenToDataChange]="listenToDataChange"
                  [submitted]="widgetFormInstanceSubmitted"
                  [popupMode]="true"
                  (formChange)="formupdate($event.form)"
                  [formData]="formData"></gen-dynamic-form>
<gen-button [type]="'primary'"
            [text]="'Encrypt'"
            (click)="encryptPassword()">
</gen-button>